require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/core-js/library/modules/es7.symbol.observable.js
// module id = 628
// module chunks = 168707334958949